import React from "react";

const CircularProgressBar = ({ progressValues, colors, size = 200, strokeWidth = 10, labels = [] }) => {
  const outerRadius = (size - strokeWidth) / 2;

  return (
    <div style={{ position: "relative", width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {/* Background Circles */}
        {progressValues.map((_, index) => {
          const currentRadius = outerRadius - index * (strokeWidth + 5);
          return (
            <circle
              key={`bg-${index}`}
              cx={size / 2}
              cy={size / 2}
              r={currentRadius}
              fill="none"
              stroke="#EAEAEA"
              strokeWidth={strokeWidth}
            />
          );
        })}

        {/* Progress Circles */}
        {progressValues.map((progress, index) => {
          const currentRadius = outerRadius - index * (strokeWidth + 5);
          const currentCircumference = 2 * Math.PI * currentRadius;
          const offset = currentCircumference - (progress / 100) * currentCircumference;
          
          return (
            <circle
              key={index}
              cx={size / 2}
              cy={size / 2}
              r={currentRadius}
              fill="none"
              stroke={colors[index] || "#000"}
              strokeWidth={strokeWidth}
              strokeDasharray={currentCircumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
              transform={`rotate(-90 ${size / 2} ${size / 2})`}
            />
          );
        })}
      </svg>
      
      {/* Tooltip */}
      {labels.map((label, index) => (
        <div
          key={`tooltip-${index}`}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            color: "white",
            padding: "5px 10px",
            borderRadius: "4px",
            fontSize: "14px",
            pointerEvents: "none",
          }}
        >
          {label}
        </div>
      ))}
    </div>
  );
};

export default CircularProgressBar;
